import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GenericHttpService } from './generic-http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RazorpayService {
  baseEndPoint = '';
  constructor(
    public httpService: GenericHttpService,
    private httpclient: HttpClient
  ) {}

  getTransactionDetails(accountNmber, params): Observable<any> {
    let endPoint = `/payment/razorpay-transaction-data/?account_id=${accountNmber}`;
    if (params) {
      endPoint +=
        '&' + this.httpService.getQueryString(params).replace(/^\?/, '');
    }
    return this.httpService.Get(endPoint);
  }

  exportTransactions(accountNmber, params): Observable<any> {
    let endPoint = `/wallet/transactions-report/?account_id=${accountNmber}`;
    if (params) {
      endPoint +=
        '&' + this.httpService.getQueryString(params).replace(/^\?/, '');
    }
    return this.httpService.Get(endPoint);
  }

  base64ToCSV(base64String: string, fileName: string) {
    const byteCharacters = atob(base64String);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);
  
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, { type: 'application/csv' });
    const csvURL = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = csvURL;
    link.download = `${fileName}.csv`;
      link.click();
      URL.revokeObjectURL(csvURL);
  }
}
